<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px; padding-top: 16px"
      >
        <span class="headline mb-0">詳細情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save" class="mr-2" v-permit.SHARP_DIM_HOLD>{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
        <v-btn @click="getDeliveryDirectors" class="ml-2">納入指示者取得</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                label="D/O NO(親)"
                v-model="order.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="フライトNO"
                v-if="order.isAir"
                v-model="order.volNo"
              ></v-text-field>
              <v-text-field
                disabled
                label="本船"
                v-else
                v-model="order.shipName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.volNo')"
                v-model="order.volNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.etd')"
                v-model="order.etd"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.loadingPort')"
                v-model="order.loadingPortName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.dischargePort')"
                v-model="order.dischargePortName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.transportMode')"
                v-model="order.transportModeCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.eta')"
                v-model="order.eta"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="納入指示者１"
                url="employees/kv"
                v-model="order.deliveryDirectorId1"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="納入指示者2"
                url="employees/kv"
                v-model="order.deliveryDirectorId2"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="納入指示者3"
                url="employees/kv"
                v-model="order.deliveryDirectorId3"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="納入指示者4"
                url="employees/kv"
                v-model="order.deliveryDirectorId4"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="納入指示者5"
                url="employees/kv"
                v-model="order.deliveryDirectorId5"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :disabled="order.status == '指示Mail送信済'"
                clearable
                label="CC"
                url="employees/kv"
                v-model="order.ccId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-data-table
        :headers="headers"
        :items="order.packages"
        :rows-per-page-items="[10]"
        class="inline-edit pb-4"
        hide-actions
        item-key="seq"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.containerNo }}</td>
          <td>{{ props.item.flag }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.cartonStartNo }}</td>
          <td>{{ props.item.cartonEndNo }}</td>
          <td>{{ props.item.perCartonQty }}</td>
          <td>{{ props.item.totalQty }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    order: {},
    selected: [],
    headers: [
      { text: 'D/O NO', value: 'doNo', sortable: false },
      { text: '海外取引先', value: 'partnerName', sortable: false },
      { text: 'I/V NO', value: 'invoiceNo', sortable: false },
      { text: 'コンテナNO', value: 'containerNo', sortable: false },
      { text: '識別No.', value: 'flag', sortable: false },
      { text: '品番', value: 'skuCode', sortable: false },
      { text: 'Carton Start', value: 'cartonStartNo', sortable: false },
      { text: 'Carton End', value: 'cartonEndNo', sortable: false },
      { text: '入れ数', value: 'perCartonQty', sortable: false },
      { text: '数量', value: 'totalQty', sortable: false },
    ],
    resolve: null,
    reject: null,
    errors: {
      CAN_NOT_RESET: '担当者を再度設定できません。',
    },
  }),
  methods: {
    getDeliveryDirectors() {
      this.$http
        .put(`/shipping-advices/reset-delivery-directors/${this.order.id}`)
        .then(() => {
          this.$message('', 'success')
          this.$http.get(`/shipping-advices/${this.order.id}`).then((res) => {
            this.order = res.data
            this.order.packages.forEach((o) => {
              o.doNo = this.order.doNo
              o.partnerName = this.order.partnerName
            })
          })
          this.$emit('refresh')
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    popup(id) {
      return this.$http.get(`/shipping-advices/${id}`).then((res) => {
        this.order = res.data
        this.order.packages.forEach((o) => {
          o.doNo = this.order.doNo
          o.partnerName = this.order.partnerName
        })
        this.show = true
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      })
    },
    save() {
      this.resolve(this.order)
      this.show = false
    },
  },
}
</script>
